<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import { AppTypography } from '~/components/base';
import useGetPrivacyPolicy from '~/composables/useGetPrivacyPolicy';
import PrivacyPolicyPageContent from '~/utils/contents/pages/PrivacyPolicyPage';
import { $sanitizeHtml } from '~/utils/helpers';

const { privacyPolicy, getPrivacyPolicy } = useGetPrivacyPolicy();

const sanitizedPrivacyPolicy = computed(() =>
  $sanitizeHtml(privacyPolicy.value),
);

onMounted(() => {
  getPrivacyPolicy();
});
</script>

<template>
  <div class="privacy-policy-page__content border bg-white p-6 md:p-10 lg:p-16">
    <AppTypography type="title-6" class="mb-8 text-center">
      {{ PrivacyPolicyPageContent.title }}
    </AppTypography>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="richtext" v-html="sanitizedPrivacyPolicy"></div>
  </div>
</template>
